import {
	ExpandLess as ExpandLessIcon,
	ExpandMore as ExpandMoreIcon,
	Autorenew as FilterOffIcon,
	Search as SearchIcon,
} from "@material-ui/icons";
import clsx from "clsx";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Card, CardBody, CardHR } from "../../../_metronic/_partials/controls";
import "./filter.scss";

function Collapsable({
	collapsable = true,
	collapsed,
	children,
	onSearch,
	onClear,
}) {
	return (
		<>
			<div
				className={clsx(
					collapsed && "d-none",
					"filter-header-container"
				)}
			>
				{collapsable && <CardHR />}
				<div className="neo4-filter-row">
					<div className="neo4-filter-fields">{children}</div>
					<div className="neo4-filter-actions">
						{onSearch && (
							<button
								type="button"
								className="btn btn-lg btn-primary"
								onClick={onSearch}
								title="Search with filters"
							>
								<span>
									<SearchIcon />
								</span>
							</button>
						)}
						{onClear && (
							<button
								type="button"
								className="btn btn-lg btn-secondary"
								onClick={onClear}
								title="Clear filters"
							>
								<span>
									<FilterOffIcon />
								</span>
							</button>
						)}
					</div>
				</div>
			</div>
		</>
	);
}

const FilterHeader = ({ collapsed, toggleCollapse }) => (
	<>
		<Row className="filter-header-container">
			<Col className="filter-header-title">
				<h4>Filter results</h4>
			</Col>
			<Col className="filter-header">
				<div>
					{toggleCollapse && (
						<button
							type="button"
							className="btn btn-lg btn-secondary toggle-button"
							onClick={toggleCollapse}
							title={
								collapsed
									? "Expand filters"
									: "Collapse filters"
							}
						>
							{collapsed ? (
								<ExpandMoreIcon title="Expand filters" />
							) : (
								<ExpandLessIcon title="Collapse filters" />
							)}
						</button>
					)}
				</div>
			</Col>
		</Row>
	</>
);

export const FiltersCard = ({
	className,
	cardShadow = true,
	collapsable = true,
	collapsed,
	setCollapsed,
	handleClearFilters,
	handleSearch,
	filtersContent,
}) => (
	<Card className="neo4-filter-card mb-4" style={{ boxShadow: !cardShadow ? "none" : "" }}>
		<CardBody className={`neo4-filter-card-body ${!collapsable ? "pb-0" : ""} ${className}`}>
			{collapsable && (
				<FilterHeader
					collapsed={collapsed}
					toggleCollapse={() => setCollapsed(!collapsed)}
				/>
			)}
			<Collapsable
				collapsable={collapsable}
				collapsed={collapsable ? collapsed : collapsable}
				onClear={handleClearFilters}
				onSearch={handleSearch}
			>
				{filtersContent()}
			</Collapsable>
		</CardBody>
	</Card>
);

export default FiltersCard;
